import {ILangdict, Langdict} from './langdict';

export class IFaculty {
  constructor(
    public id: string,
    public description: ILangdict) {
  }
}

export class Faculty extends IFaculty {
  description: Langdict;
  id: string;

  constructor(obj: IFaculty) {
    super(obj.id,
      new Langdict(obj.description));
  }
}
